'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _Object$keys = require('babel-runtime/core-js/object/keys')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

var _interopRequireWildcard = require('babel-runtime/helpers/interop-require-wildcard')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _componentsComponent = require('../../components/Component');

var _componentsComponent2 = _interopRequireDefault(_componentsComponent);

var _dbinfo = require('../../dbinfo');

var _dbinfo2 = _interopRequireDefault(_dbinfo);

var _constants = require('../../constants');

var Constants = _interopRequireWildcard(_constants);

var _componentsToolbar = require('../../components/Toolbar');

var _componentsToolbar2 = _interopRequireDefault(_componentsToolbar);

var _reactBootstrap = require('react-bootstrap');

var _reactisForms = require('reactis-forms');

var _reactisInputs = require('reactis-inputs');

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reactisModal = require('reactis-modal');

var _componentsFormDB = require('../../components/FormDB');

var _componentsFormDB2 = _interopRequireDefault(_componentsFormDB);

var _reactisLoader = require('reactis-loader');

var _componentsActionButton = require('../../components/ActionButton');

var _componentsActionButton2 = _interopRequireDefault(_componentsActionButton);

var _componentsSaveButton = require('../../components/SaveButton');

var _componentsSaveButton2 = _interopRequireDefault(_componentsSaveButton);

var _components = {
	_$Form: {
		displayName: 'Form'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var Form = (function (_FormDB) {
	_inherits(Form, _FormDB);

	function Form(props, context) {
		_classCallCheck(this, _Form);

		_FormDB.call(this, props, context);

		this.api = {
			fetch: 'user.fetch',
			save: 'user.save',
			remove: 'user.delete'
		};

		this.changeEvent = 'user.change';

		this.messages = {
			remove: 'Opravdu si přejete uživatele odstranit?',
			notfound: 'Uživatel nenalezen!'
		};

		this.schema = {
			name: {
				'class': _reactisInputs.TextInput,
				label: 'Jméno',
				rules: {
					presence: { message: 'Jméno je povinná položka!' }
				}
			},
			surname: {
				'class': _reactisInputs.TextInput,
				label: 'Příjmení',
				rules: {
					presence: { message: 'Příjmení je povinná položka!' }
				}
			},
			email: {
				'class': _reactisInputs.TextInput,
				label: 'E-mail',
				value: '@',
				rules: {
					email: { message: 'Zadejte platný e-mail!' }
				}
			},
			active: {
				'class': _reactisInputs.Checkbox,
				label: 'Aktivní',
				value: true
			},
			login: {
				'class': _reactisInputs.TextInput,
				label: 'Přihlašovací jméno',
				visible: function visible(form) {
					return form.active;
				}
			},
			password: {
				'class': _reactisInputs.TextInput,
				type: 'password',
				label: 'Heslo',
				visible: function visible(form) {
					return form.active;
				}
			},
			passwordConfirm: {
				'class': _reactisInputs.TextInput,
				type: 'password',
				label: 'Heslo pro kontrolu',
				visible: function visible(form) {
					return form.active;
				},
				rules: {
					equality: {
						attribute: 'password',
						message: 'Hesla se musejí shodovat!'
					}
				}
			},
			image: {
				'class': _reactisInputs.ImageUpload,
				label: 'Foto'
			},
			notice: {
				'class': _reactisInputs.TextArea,
				label: 'Poznámka',
				style: { height: '60px' }
			}
		};
		this.form = new _reactisForms.FormManager(this.schema);
	}

	Form.prototype.componentDidMount = function componentDidMount() {
		var _this = this;

		this.form.on('change', function (key, value, values) {
			if (key == 'name' || key == 'surname') {
				_this.title = (values.get('name') ? values.get('name') : '') + ' ' + (values.get('surname') ? values.get('surname') : '');
			}
			_this.changed = true;
		});
		_FormDB.prototype.componentDidMount.call(this);
	};

	Form.prototype.updateTab = function updateTab(data) {
		this.props.updateTab({ title: data.name + ' ' + data.surname });
	};

	Form.prototype.render = function render() {
		var _this2 = this;

		var loading = !!(this.props.form && this.props.form.get('loading'));

		var canEdit = true || this.user.isAllowed('user', 'update');
		var saveButton = _react2['default'].createElement(_componentsSaveButton2['default'], {
			disabled: !canEdit,
			loading: !!(this.props.form && this.props.form.get('saving')),
			onClick: function () {
				return _this2.save();
			}
		});

		var btns = _react2['default'].createElement(
			_reactBootstrap.ButtonToolbar,
			null,
			saveButton,
			this.props.id > 0 && _react2['default'].createElement(
				_componentsActionButton2['default'],
				{ disabled: !canEdit, bsStyle: 'danger', icon: 'fa fa-trash-o', onClick: function () {
						return _this2.remove();
					} },
				'Odstranit'
			)
		);

		return _react2['default'].createElement(
			'div',
			{ style: { position: 'relative' } },
			_react2['default'].createElement(_reactisLoader.Loader, { visible: !!(this.props.form && this.props.form.get('loading')) }),
			_react2['default'].createElement(
				_reactisForms.RxForm,
				{ ref: 'form', form: this.form, id: 'tab_' + this.props.tabid },
				_react2['default'].createElement(_componentsToolbar2['default'], { title: 'Uživatel', buttons: btns }),
				_react2['default'].createElement(
					'div',
					{ className: 'row' },
					_react2['default'].createElement(
						'div',
						{ className: 'col-md-6' },
						_react2['default'].createElement(
							'table',
							{ className: 'form' },
							_react2['default'].createElement(
								'tbody',
								null,
								_Object$keys(this.schema).map(function (key) {
									return _react2['default'].createElement(_reactisForms.FormRow, { key: key, visible: _this2.schema[key].visible, name: key, labelWidth: '135' });
								}),
								_react2['default'].createElement(
									_reactisForms.FormRow,
									{ className: 'buttons' },
									saveButton
								)
							)
						)
					)
				)
			)
		);
	};

	var _Form = Form;
	Form = _wrapComponent('_$Form')(Form) || Form;
	Form = _reactRedux.connect(function (state, props) {
		return {
			form: state.forms.get('tab_' + props.tabid)
		};
	}, function (dispatch) {
		return { actions: _redux.bindActionCreators(_reactisForms.actions, dispatch) };
	}, null, { withRef: true })(Form) || Form;
	return Form;
})(_componentsFormDB2['default']);

exports['default'] = Form;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/User/Form.js
 ** module id = 976
 ** module chunks = 2
 **/